import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "41",
  height: "41",
  viewBox: "0 0 41 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "mask0_11017_35679",
      style: {"mask-type":"alpha"},
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "41",
      height: "41"
    }, [
      _createElementVNode("rect", {
        x: "0.444336",
        y: "0.669922",
        width: "40",
        height: "40",
        fill: "#D9D9D9"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#mask0_11017_35679)" }, [
      _createElementVNode("path", {
        d: "M18.7778 30.6699L28.7778 20.6699L18.7778 10.6699",
        stroke: "#828282",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }